import React, { useState, ReactNode, useEffect, useCallback } from 'react'
import { Box } from '@mui/material'
import { CheckboxProps } from '@mui/material/Checkbox'
import { FormControlLabelProps } from '@mui/material/FormControlLabel'
import ColoredBox from 'components/ColoredBox'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useQueryEcrfElementQuery } from "utils/elementQuery";
import { ElementQuery } from "types/form/ElementQuery";
import { DataGrid, GridColDef, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";

export interface TableFormikProps
  extends Omit<CheckboxProps, 'name' | 'onChange' | 'onBlur' | 'error'> {
  name: string
  label?: ReactNode
  labelPlacement?: FormControlLabelProps['labelPlacement']
  children?: any[]
  element: any;
  data?: any;
  status?: boolean
  options?: any
  permissionOperations?: any
}

const Table = ({ element }: TableFormikProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [rows, setRows] = useState<any[]>([]);

  const { isLoading, data: { data: qd } = {} as { data: ElementQuery | any } }  = useQueryEcrfElementQuery(
    id || '', element?.id
  );

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const fetch = useCallback(() => {
    if (!qd || !qd.columns || !qd.rows) return;

    const headings: GridColDef[] = qd.columns.map((col: string) => ({
      field: col,
      headerName: col,
      flex: 1,
    }));
    setColumns(headings);

    const structuredRows = qd.rows.map((row: any, index: number) => ({
      id: index,
      ...row,
    }));
    setRows(structuredRows);
  }, [qd]);

  useEffect(() => {
    fetch();
  }, [qd]);

  return (
    <Box pt={3} pb={3}>
      <ColoredBox
        style={{ boxShadow: "none", overflow: "hidden" }}
        p={1}
        mb={3}
        maxWidth="100%"
        ml="auto"
        mr="auto"
      >
        <DataGrid
          autoHeight
          rows={rows}
          columns={columns}
          loading={isLoading}
          disableColumnMenu
          disableRowSelectionOnClick
          slots={{
            toolbar: CustomToolbar,
          }}
          sx={{
            minWidth: 900,
            border: "none",
            "& .MuiDataGrid-cell": {
              py: 1,
              px: 2,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#F5F5F5",
              fontWeight: 600,
            },
          }}
          localeText={{
            noRowsLabel: t("No data"),
          }}
        />
      </ColoredBox>
    </Box>
  );
};

export default Table;